import { render, staticRenderFns } from "./brand-list.vue?vue&type=template&id=0cba3977&scoped=true&"
import script from "./brand-list.vue?vue&type=script&lang=js&"
export * from "./brand-list.vue?vue&type=script&lang=js&"
import style0 from "./brand-list.vue?vue&type=style&index=0&id=0cba3977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba3977",
  null
  
)

export default component.exports